module.exports = __webpack_public_path__ + "img/tj.451e5cf.svg";